import * as Actions from './root.actions';
import { AusmitError } from "../../shared/interfaces";
import { PaginatorModel } from "../../shared/interfaces/PaginatorModel";

/*Defining the state shape*/
export interface State {
	error: AusmitError | null;
	hasError: boolean;
	requestProcessing: boolean;
	GetBanners: {
		response: PaginatorModel | null;
	};
	GetBannersForProduct: {
		response: PaginatorModel | null;
	};
	GetBannersForStore: {
		response: PaginatorModel | null;
	};
	GetPopularJewellers: {
		response: PaginatorModel | null
	}
}

/*Setting the initial state*/
export const initialState: State = {
	error: null,
	hasError: false,
	requestProcessing: false,
	GetBanners: {
		response: null,
	},
	GetBannersForProduct: {
		response: null,
	},
	GetBannersForStore: {
		response: null,
	},
	GetPopularJewellers: {
		response: null,
	}
};

/*Creating the reducer function*/
export function RootReducer(
	state = initialState,
	action: Actions.Actions
): State {
	switch (action.type) {
		case Actions.ActionTypes.GetBannersSuccess: {
			return {
				...state,
				GetBanners: {
					response: action.payload,
				}
			};
		}
		case Actions.ActionTypes.GetBannersError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetBanners: {
					response: null,
				}
			};
		}

		case Actions.ActionTypes.GetBannersForProductSuccess: {
			return {
				...state,
				GetBannersForProduct: {
					response: action.payload,
				}
			};
		}
		case Actions.ActionTypes.GetBannersForProductError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetBannersForProduct: {
					response: null,
				}
			};
		}

		case Actions.ActionTypes.GetBannersForStoreSuccess: {
			return {
				...state,
				GetBannersForStore: {
					response: action.payload,
				}
			};
		}
		case Actions.ActionTypes.GetBannersForStoreError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetBannersForStore: {
					response: null,
				}
			};
		}

		case Actions.ActionTypes.GetBannersSuccess: {
			return {
				...state,
				GetBanners: {
					response: action.payload,
				}
			};
		}
		case Actions.ActionTypes.GetBannersError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetBanners: {
					response: null,
				}
			};
		}

		case Actions.ActionTypes.GetPopularJewellersSuccess: {
			return {
				...state,
				GetPopularJewellers: {
					response: action.payload,
				}
			};
		}
		case Actions.ActionTypes.GetPopularJewellersError: {
			return {
				...state,
				error: action.payload,
				hasError: true,
				GetPopularJewellers: {
					response: null,
				}
			};
		}

		default:
			return state;
	}
}
